import { connect, MapDispatchToProps } from 'react-redux';
import { editDeviation } from '../../redux/deviations/actionCreators';
import { Props } from './TierSidebarCard';

type DispatchProps = Pick<Props, 'editTier'>;
type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { deviation }
) => ({
  editTier: () => dispatch(editDeviation({ deviation })),
});

export default connect(null, mapDispatchToProps);
